import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ModalTypes } from '../Constants';
import Styles from './MissionSet/BaseComponent.cssmodule.less';
import Render from './Render';
import { PrebuiltHintData } from '../static';

import Util from '../utils/util';
import { updateCommonData, RELOAD_ENTRY } from '../actions';
import { bindActionCreators } from 'redux';

class Free extends Component {
    constructor(props) {
        super(props);

        this.freePopup = new entrylms.Modal();
    }

    /* Lifecycle Events */
    componentDidMount() {
        const data = this.props.data;
        this.popupView = $('<div>');
        this.renderView = new Render({
            target: this.popupView,
        });

        this.renderView.on('click', (e, data = {}) => {
            const { contents } = this.props.data;
            if (data.type === 'default') {
                this.freePopup.modalData = {
                    type: 'MANUAL',
                    content: 'FREE',
                };
            } else if (data.type === 'intro') {
                this.showIntroPopup(this.props.data);
                return;
            } else if (data.type === 'hint') {
                const items = contents[data.value].items;
                this.freePopup.modalData = items.map((item) => {
                    item.type = ModalTypes.HINT;
                    item.title = item.title || contents[data.value].title || '';
                    return item;
                });
            } else {
                const items = contents[data.value].items;
                this.freePopup.modalData = PrebuiltHintData[items.content];
            }

            this.freePopup.itemIndex = 0;
            this.freePopup.show();
        });
        this.initOption = {
            type: 'workspace',
            fonts: EntryStatic.fonts,
            libDir: '/lib',
            device: device,
            loadInterface: false,
            commentDisable: true,
            backpackDisable: true,
        };
        Object.assign(this.initOption, data.injectOption);

        if (Entry.type && Entry.type != 'invisible') {
            Entry.changeContainer(
                document.getElementById(Styles.freeComponent)
            );
            Entry.reloadOption(this.initOption);
        } else {
            var device =
                window.platform && window.platform.type ? 'tablet' : null;
            Entry.init(
                document.getElementById(Styles.freeComponent),
                this.initOption
            );
        }
        if (!data.injectOption || !data.injectOption.hintDisable) {
            this.PopupList = new Entry.PopupList(this.popupView);
            Entry.propertyPanel.addMode('hint', this.PopupList);
        }
        Entry.propertyPanel.select('object');
        this.loadData(this.props.data);
    }

    componentDidUpdate(prevProps) {
        const previousId = prevProps.data ? prevProps.data._id : '';
        const isReloadAction = !prevProps.common.reload && this.props.common.reload;
        if(isReloadAction) {
            this.reloadEntry();
            this.props.actions.updateCommonData(RELOAD_ENTRY, false);
            return ;
        }

        if (previousId !== this.props.data._id || this.props.data.reset) {
            if (this.props.data.injectOption) {
                Entry.reloadOption({ commentDisable: true, backpackDisable: true, ...this.props.data.injectOption });
            }
            this.loadData(this.props.data);
        }
    }

    reloadEntry() {
        const temp = Entry.exportProject();
        Entry.clearProject();
        Entry.disposeContainer();
        Entry.reloadBlock();
        Entry.init(document.getElementById(Styles.freeComponent), this.initOption);
        entrylms.emit('reloadWorkspace', temp);
    }

    componentWillUnmount() {
        Entry.propertyPanel.removeMode('hint');
    }

    /* Lifecycle Events */

    loadData(data) {
        if (data) {
            const { basicProject, doneProject, injectOption } = data;
            const GOAL = 'goal';

            Entry.targetChecker = undefined;

            if (basicProject) {
                Entry.clearProject();
                this.setAvailableBlocks(data);
                Entry.loadProject(basicProject);
                Entry.scene.selectScene();
            }

            if (doneProject && (!injectOption || !injectOption.hintDisable)) {
                const donepr = new Entry.DoneProject(doneProject._id);
                Entry.propertyPanel.addMode(GOAL, donepr);
            } else {
                Entry.propertyPanel.removeMode(GOAL);
            }

            this.showIntroPopup(data);

            if (this.renderView) {
                this.renderView.renderData = {
                    type: 'POPUP_LIST',
                    content: data.contents,
                };
            }
        }
    }

    setAvailableBlocks(data) {
        if (!data) return;
        var blockJSON = data.availableBlocks;
        var variableCategory = blockJSON.filter(function(json) {
            return json.category === 'variable' && json.blocks;
        });

        if (variableCategory && variableCategory.length !== 0)
            variableCategory = variableCategory[0];
        var blocks = variableCategory.blocks || [];

        for (var i = 0; i < blocks.length; i++) {
            var block = blocks[i];
            if (block == 'variableAddButton' || block == 'listAddButton')
                blocks.splice(i--, 1);
        }

        var injectOption = data.injectOption ? data.injectOption : {};
        if (injectOption.listEnable === true)
            variableCategory.blocks.unshift('listAddButton');
        if (injectOption.variableEnable === true)
            variableCategory.blocks.unshift('variableAddButton');

        blocks = null;

        if (Entry.functionEnable) {
            var funcCategory = blockJSON.filter(function(json) {
                return json.category === 'func' && json.blocks;
            });
            if (!funcCategory || funcCategory.length === 0) {
                var funcCategory = {
                    category: 'func',
                    blocks: [],
                };
                blockJSON.splice(blockJSON.length - 1, 0, funcCategory);
            } else funcCategory = funcCategory[0];
            blocks = funcCategory.blocks || [];
            if (blocks) {
                var index = blocks.indexOf('functionAddButton');
                if (index > -1) blocks.splice(index, 1);
                funcCategory.blocks.unshift('functionAddButton');
            }
            blocks = null;
        }

        var hwCategory = blockJSON.filter(function(json) {
            return json.category === 'arduino' && json.blocks;
        });

        if (hwCategory && hwCategory.length !== 0) hwCategory = hwCategory[0];
        blocks = hwCategory.blocks || [];

        var spliceTypes = [
            'arduino_download_connector',
            'download_guide',
            'arduino_download_source',
            'arduino_connected',
            'arduino_reconnect',
        ];

        for (i = 0; i < blocks.length; i++) {
            if (spliceTypes.indexOf(blocks[i]) > -1) blocks.splice(i--, 1);
        }

        if (blocks && blocks.length) blocks.unshift.apply(blocks, spliceTypes);

        blockJSON = blockJSON.filter((json) => {
            return json.blocks;
        });

        const blockMenu = Entry.getMainWS().blockMenu;
        blockMenu.setCategoryData(blockJSON);
        const event = blockMenu.categoryDoneEvent.attach(this, function() {
            blockMenu.categoryDoneEvent.detach(event);
            Util.unbanHW();
            blockMenu.hwCodeOutdated = true;
            blockMenu._generateHwCode();
            blockMenu.reDraw();
        });
    }

    showIntroPopup(data) {
        if (data && data.contents && data.contents.length) {
            data.contents.map((content) => {
                if (content.type !== 'intro') return;
                this.freePopup.modalData = content.items.map((item) => {
                    item.type = ModalTypes.INTRO;
                    item.title = item.title || data.parentTitle || '';
                    return item;
                });
                this.freePopup.itemIndex = 0;
                this.freePopup.show();
            });
        }
    }

    render() {
        return <div id={Styles.freeComponent} className={Styles.wsComponent} />;
    }
}

Free.displayName = 'Free';
Free.propTypes = {};
Free.defaultProps = {
    data: {
        title: '',
    },
};
const mapStateToProps = (state) => ({
    ...state,
});

function mapDispatchToProps(dispatch) {
    const actions = { updateCommonData };
    return { actions: bindActionCreators(actions, dispatch) };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Free);



// WEBPACK FOOTER //
// ./components/Free.js